/** Route guard that redirects learners to /welcome until onboarding is completed. */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import LoadingIcon from '@/foundation/ui/LoadingIcon';

export function RequireLearnerOnboarding() {
  const { loading, onboardingCompleted } = useAuth();
  const location = useLocation();

  // Render a loading indicator (rather than `null`) so the UI doesn't flash
  // empty content while auth is bootstrapping. If profile fetch hangs, the
  // user sees feedback rather than a permanently blank screen.
  if (loading) {
    return (
      <div
        className="flex min-h-dvh items-start justify-center pt-[28vh]"
        style={{ background: 'var(--color-bg)' }}
      >
        <LoadingIcon size="lg" />
      </div>
    );
  }

  // If onboarding not completed, redirect to /welcome (preserving intended path)
  if (!onboardingCompleted && location.pathname !== '/welcome') {
    return <Navigate to="/welcome" replace state={{ from: location.pathname }} />;
  }

  // If onboarding IS completed, redirect away from /welcome.
  if (onboardingCompleted && location.pathname === '/welcome') {
    const intended = (location.state as { from?: string })?.from;
    return <Navigate to={intended || '/'} replace />;
  }

  return <Outlet />;
}
